class LiteYTEmbed extends HTMLElement {
	constructor() {
		super();

		this.videoId = encodeURIComponent(this.getAttribute('videoid'));
		this.thumbnailSize = encodeURIComponent(
			this.getAttribute('thumbnail-size')
		);
		this.posterUrl = `https://i.ytimg.com/vi_webp/${this.videoId}/${this.thumbnailSize}.webp`;
	}

	connectedCallback() {
		if ('loading' in HTMLImageElement.prototype) {
			this.addCoverImage(this.posterUrl);
		} else {
			this.style.backgroundImage = `url("${this.posterUrl}")`;
		}

		const playBtn = document.createElement('button');
		playBtn.classList.add('play-button');
		playBtn.setAttribute('aria-label', 'Play video');

		const shape = document.createElement('div');
		shape.classList.add('shape');
		playBtn.append(shape);

		this.append(playBtn);

		this.addEventListener('pointerover', LiteYTEmbed.warmConnections, {
			once: true,
		});
		this.addEventListener('click', () => this.addIframe(), {
			once: true,
		});
	}

	static addPrefetch(kind, url, as) {
		const linkElem = document.createElement('link');
		linkElem.rel = kind;
		linkElem.href = url;
		if (as) {
			linkElem.as = as;
		}
		linkElem.crossOrigin = 'anonymous';
		document.head.append(linkElem);
	}

	static warmConnections() {
		if (LiteYTEmbed.preconnected) {
			return;
		}

		LiteYTEmbed.addPrefetch(
			'preconnect',
			'https://www.youtube-nocookie.com'
		);
		LiteYTEmbed.addPrefetch('preconnect', 'https://www.google.com');
		LiteYTEmbed.addPrefetch(
			'preconnect',
			'https://googleads.g.doubleclick.net'
		);
		LiteYTEmbed.addPrefetch('preconnect', 'https://static.doubleclick.net');

		LiteYTEmbed.preconnected = true;
	}

	addCoverImage(imageUrl) {
		const attrs = {
			loading: 'lazy',
			height: 360,
			width: 480,
			src: imageUrl,
			alt: 'Thumbnail',
			style: 'position:absolute;width:100%;height:auto;',
		};

		const image = document.createElement('img');

		Object.entries(attrs).forEach((item) => {
			const [key, value] = item;
			image.setAttribute(key, value);
		});

		this.append(image);
	}

	addIframe() {
		const iframeEl = document.createElement('iframe');
		iframeEl.width = '560';
		iframeEl.height = '315';
		iframeEl.allow =
			'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
		iframeEl.allowFullscreen = true;
		iframeEl.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(
			this.videoId
		)}?autoplay=1&rel=0`;
		this.append(iframeEl);

		this.classList.add('lyt-activated');

		// Set focus for a11y
		iframeEl.focus();
	}
}

if ('customElements' in window) {
	if (!customElements.get('lite-youtube')) {
		customElements.define('lite-youtube', LiteYTEmbed);
	}
}
